import React, { useCallback, useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { SearchOutlined } from '@ant-design/icons';
import { useDebounce } from '@/hooks/useDebounce';
import * as S from './styles';

export function SearchBarInput() {
	const [searchValue, setSearchValue] = useState('');

	const debouncedSearch = useDebounce((value: string) => {
		// onSearch(value);
		console.log(value);
	}, 500);

	const handleSearch = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			setSearchValue(value);
			debouncedSearch(value);
		},
		[debouncedSearch]
	);

	return (
		<S.SearchInput
			placeholder={I18n.get('Search for a report')}
			prefix={<SearchOutlined style={{ fontSize: 16 }} />}
			value={searchValue}
			onChange={handleSearch}
			allowClear
		/>
	);
}
